module.exports = __webpack_public_path__ + "static/img/69 (1).a934df5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/69 (1).jpg
// module id = 78SH
// module chunks = 0